import ApiService from "./ApiService";

export async function apiGetMenu(data) {
  return ApiService.fetchData({
    url: "/api/form/getForms",
    method: "post",
    data,
  });
}
